const PALETTE = [
  '#2f6f82','#4a8a60','#b3823a','#8a5ca8','#b04a42',
  '#284a72','#6b7f3e','#b86043'
]

interface AvatarProps {
  name: string
  size?: number
  id?: number
}

export function Avatar({ name, size = 36, id }: AvatarProps) {
  const seed = id !== undefined ? id : name.charCodeAt(0) + (name.charCodeAt(1) || 0)
  const color = PALETTE[seed % PALETTE.length]
  const initials = name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map(w => w[0])
    .join('')
    .toUpperCase()

  return (
    <div
      className="av"
      style={{
        width: size,
        height: size,
        background: color,
        fontSize: size * 0.38,
      }}
    >
      {initials}
    </div>
  )
}
